import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { HeroSlide } from '../../types';
import styles from './Hero.module.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

interface HeroProps {
  slides: HeroSlide[];
  autoPlayInterval?: number;
}

const Hero: React.FC<HeroProps> = ({ slides, autoPlayInterval = 3500 }) => {
  return (
    <section className={styles.heroSection}>
      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        centeredSlides={true}
        autoplay={{
          delay: autoPlayInterval,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        className={styles.mySwiper}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id} className={styles.swiperSlide}>
            <div
              className={styles.slideBackground}
              style={{ backgroundImage: `url(${slide.image})` }}
            />
            <div className={styles.slideContent}>
              <a href="/company/about">
                <p
                  className={styles.slideTitle}
                  dangerouslySetInnerHTML={{ __html: slide.title }}
                />
                <p className={styles.slideSubtitle}>{slide.subtitle}</p>
                <img src="/images/arrow.png" alt="자세히보기" className={styles.slideArrow} />
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Hero;
